export const BI_EVENT_TYPES = {
    PRO_CATALOG_EDUCATION_BANNER_IS_SHOWN: 'Pro_catalog_education_banner_is_shown',
    DISMISS_PRO_EDUCATION_BANNER: 'clicked_on_dismiss_pro_education_banner',
    TOGGLE_ITEM_CLICK: 'click_listing_type_toggle',
};

export const EXPERTS_TOGGLE_ITEM_BACKGROUND_IMAGE_URL =
    'https://fiverr-res.cloudinary.com/image/upload/f_auto,q_auto/v1/attachments-dev/generic_asset/asset/bad0942369f02daf3c95978af7e3baca-1688632723550/Pool%20confetti.gif';
